module.exports = __webpack_public_path__ + "static/img/3.5862a43.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/pinterest/3.jpeg
// module id = xcdD
// module chunks = 46